import type { Bootstrapper } from "./Bootstrapper";
import { ApplicationAgentBootstrapper } from "./Bootstrappers/ApplicationAgentBootstrapper";
import { AuthenticationBootstrapper } from "./Bootstrappers/AuthenticationBootstrapper";
import { CloseDetectionBootstrapper } from "./Bootstrappers/CloseDetectionBootstrapper";
import { DarkModeBootstrapper } from "./Bootstrappers/DarkModeBootstrapper";
import { HistoryBootstrapper } from "./Bootstrappers/HistoryBootstrapper";
import { LocaleBootstrapper } from "./Bootstrappers/LocaleBootstrapper";
import { LocationBootstrapper } from "./Bootstrappers/LocationBootstrapper";
import { LoggingBootstrapper } from "./Bootstrappers/LoggingBootstrapper";
import { MicrosoftClarityBootstrapper } from "./Bootstrappers/MicrosoftClarityBootstrapper";
import { ReduxBootstrapper } from "./Bootstrappers/ReduxBootstrapper";
import { SaleBootstrapper } from "./Bootstrappers/SaleBootstrapper";
import { ServiceWorkerBootstrapper } from "./Bootstrappers/ServiceWorkerBootstrapper";
import { StorageBootstrapper } from "./Bootstrappers/StorageBootstrapper";
import { StyleBootstrapper } from "./Bootstrappers/StyleBootstrapper";
import { SystemInformationBootstrapper } from "./Bootstrappers/SystemInformationBootstrapper";
import { TrainingModeBootstrapper } from "./Bootstrappers/TrainingModeBootstrapper";
import { VersionBootstrapper } from "./Bootstrappers/VersionBootstrapper";

console.debug("Starting bootstrapping...");

const bootstrappers: Array<Bootstrapper> = [
    new LoggingBootstrapper(),
    new MicrosoftClarityBootstrapper(),
    new SystemInformationBootstrapper(),
    new ServiceWorkerBootstrapper(),
    new HistoryBootstrapper(),
    new StyleBootstrapper(),
    new StorageBootstrapper(),
    new ReduxBootstrapper(),
    new DarkModeBootstrapper(),
    new ApplicationAgentBootstrapper(),
    new AuthenticationBootstrapper(),
    new SaleBootstrapper(),
    new LocationBootstrapper(),
    new TrainingModeBootstrapper(),
    new LocaleBootstrapper(),
    new VersionBootstrapper(),
    new CloseDetectionBootstrapper(),
];

for(const bootstrapper of bootstrappers) {
    await bootstrapper.bootstrap();
}

console.debug("Bootstrapping complete, ready to start Shopfront");
